export enum MedChronAssetTabs {
  ALL_EVENTS = 'all-events',
  DETAILED_VIEW = 'detailed-view',
  SOURCE_FILES = 'source-files',
}

export const getMedChronAssetTabName = (tab: MedChronAssetTabs) => {
  switch (tab) {
    case MedChronAssetTabs.ALL_EVENTS:
      return 'All Events'
    case MedChronAssetTabs.DETAILED_VIEW:
      return 'Detailed View'
    case MedChronAssetTabs.SOURCE_FILES:
      return 'Source Files'
  }
}

export enum MedChronAssetRouteSegments {
  ADD_FILES = 'add-files',
}

// Update polling backs off 5s -> 10s -> 15s while a run is active.
export const kMedChronAssetPollIntervalsMs = [5000, 10000, 15000]

export const kMedChronAssetAcceptedFileTypes = {
  'application/pdf': ['.pdf'],
}

// Read-only collaborators can't start a build; shown in the disabled Add Files tooltip and the owner notice fallback.
export const kMedChronOwnerOnlyBuildMessage = 'Only the matter owner can initiate a medical chronology build.'
// Owner-attributed variant (owner name known); shown in the owner notice strip.
export const kMedChronOwnerOnlyBuildOwnerMessage = 'Only they can initiate a medical chronology build.'

// Read-only collaborators viewing an in-flight or built chronology; shown in the tabs-row "Viewing" pill.
export const kMedChronOwnerOnlyUpdateMessage = 'Only the matter owner can update this chronology.'
export const kMedChronEditorBuildMessage = 'Only the matter owner and editors can initiate a medical chronology build.'
export const kMedChronEditorUpdateMessage = 'Only the matter owner and editors can update this chronology.'

export const MED_CHRON_FOLDER_NAME = 'Medical Chronology'
